

<template>
  <!-- Error Page Area Start -->
  <div class="error-page-area">
    <img src="../assets/img/shape_10.png" alt="shape" class="shape_10">
    <img src="../assets/img/shape_11.png" alt="shape" class="shape_11">
    <img src="../assets/img/shape_12.png" alt="shape" class="shape_12">
    <img src="../assets/img/shape_13.png" alt="shape" class="shape_13">
    <img src="../assets/img/shape_14.png" alt="shape" class="shape_14">
    <img src="../assets/img/shape_15.png" alt="shape" class="shape_15">
    <img src="../assets/img/shape_16.png" alt="shape" class="shape_16">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="error-page-box">
            <h2 class="error_bg">Oops!</h2>
            <h4>404 - page not found</h4>
            <p>The page you are looking for might have been remmoved had its name changed or is temporarily unavailable</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Error Page Area End -->
</template>
<script>
export default {
  name: '404Page'
}
</script>



// WEBPACK FOOTER //
// src/views/404.vue